import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { IconTick, Box, Tag } from "braid-design-system";
import { translations } from "../../../../../components/SkillsMatch/SkillsMatchSignedIn/SelectableQualities/.vocab/index.mjs";
import { overflow } from "../SkillsMatchSignedIn.css.mjs";
const QualityTag = ({
  item,
  isAdded,
  onUserAction
}) => {
  const { t } = useTranslations(translations);
  const { text } = item.keyword;
  const tagProps = {
    ...isAdded ? {
      icon: /* @__PURE__ */ jsx(IconTick, { data: { testid: "iconTick" } }),
      clearLabel: t("Remove {quality}", {
        quality: text
      }),
      onClear: () => onUserAction(item),
      state: "selected"
    } : {
      addLabel: t("Add {quality}", {
        quality: text
      }),
      onAdd: () => onUserAction(item),
      state: "default"
    }
  };
  return /* @__PURE__ */ jsx(Box, { className: overflow, children: /* @__PURE__ */ jsx(Tag, { size: "small", ...tagProps, children: text }) });
};
export {
  QualityTag
};
